import { Component, Input } from '@angular/core';
import { MediaPlayerFile } from '../../../../interfaces/media-player-store.interface';

@Component({
  selector: 'upload-progress-viewer',
  templateUrl: './upload-progress-viewer.component.html',
  styleUrl: './upload-progress-viewer.component.scss',
  standalone: false,
})
export class UploadProgressViewerComponent {
  @Input() file: MediaPlayerFile;

  get fileData(): any[] {
    return (this.file as any)?.data || [];
  }

  public onImageError(event: Event): void {
    const img: HTMLImageElement = event.target as HTMLImageElement;
    if (img) {
      img.src = 'assets/img/icons/file.svg';
    }
  }
}
